import React, { useState } from 'react';

function Contact() {
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [showSuccess, setShowSuccess] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);

        const formData = {
            name: e.target.name.value,
            email: e.target.email.value,
            subject: e.target.subject.value,
            message: e.target.message.value
        };

        try {
            // الإرسال إلى Netlify Forms
            const response = await fetch('/', {
                method: 'POST',
                headers: { 
                    'Content-Type': 'application/x-www-form-urlencoded' 
                },
                body: new URLSearchParams({
                    'form-name': 'contact-form',
                    ...formData
                }).toString()
            });

            if (response.ok) {
                setShowSuccess(true);
                e.target.reset();
                
                // إخفاء رسالة النجاح بعد 5 ثواني
                setTimeout(() => {
                    setShowSuccess(false);
                }, 5000);
            } else {
                throw new Error('فشل في الإرسال');
            }
        } catch (error) {
            alert('عذراً، حدث خطأ في إرسال الرسالة. يرجى المحاولة مرة أخرى.');
            console.error('Form submission error:', error);
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <section id="contact" className="py-5">
            <div className="container py-5">
                <h2 className="text-center fw-bold section-title">اتصل بي</h2>
               
                <div className="row mt-5">
                    <div className="col-lg-5 mb-5 mb-lg-0">
                        <h3 className="fw-bold mb-4">دعنا نتواصل</h3>
                        <p className="mb-4">
                            أنا متاح للمشاريع والفرص الجديدة. يمكنك التواصل معي من خلال النموذج المجاور أو مباشرة عبر وسائل التواصل التالية:
                        </p>

                        <div className="mb-4">
                            <div className="d-flex align-items-center mb-3">
                                <div className="bg-primary bg-opacity-10 p-3 rounded-circle me-3">
                                    <i className="fas fa-envelope text-primary"></i>
                                </div>
                                <div>
                                    <h5 className="fw-bold mb-0">البريد الإلكتروني</h5>
                                    <p className="text-muted mb-0">alaizari967@gmail.com</p>
                                </div>
                            </div>
                           
                            <div className="d-flex align-items-center mb-3">
                                <div className="bg-primary bg-opacity-10 p-3 rounded-circle me-3">
                                    <i className="fas fa-phone text-primary"></i>
                                </div>
                                <div>
                                    <h5 className="fw-bold mb-0">الهاتف</h5>
                                    <p className="text-muted mb-0">784442005 967+</p>
                                </div>
                            </div>
                           
                            <div className="d-flex align-items-center">
                                <div className="bg-primary bg-opacity-10 p-3 rounded-circle me-3">
                                    <i className="fas fa-location-dot text-primary"></i>
                                </div>
                                <div>
                                    <h5 className="fw-bold mb-0">الموقع</h5>
                                    <p className="text-muted mb-0">اليمن: صنعاء</p>
                                </div>
                            </div>
                        </div>

                        <div className="mt-4">
                            <h5 className="fw-bold mb-3">تابعني على</h5>
                            <div className="d-flex gap-2">
                                <a href="https://github.com/Salahaldeen77" target='_blank' rel="noreferrer" className="social-icon bg-light text-primary">
                                    <i className="fab fa-github"></i>
                                </a>
                                <a href='https://wa.me/967784442005' target='_blank' rel="noreferrer" className="social-icon bg-light text-primary">
                                    <i className="fab fa-whatsapp"></i>
                                </a>
                                <a href='https://t.me/Salahaldeen967' target='_blank' rel="noreferrer" className="social-icon bg-light text-primary">
                                    <i className='fab fa-telegram'></i>
                                </a>
                                <a href="https://www.facebook.com/Salahaldeen777988" target='_blank' rel="noreferrer" className="social-icon bg-light text-primary">
                                    <i className="fab fa-facebook"></i>
                                </a>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-7">
                        <div className="card border-0 shadow-sm rounded-3">
                            <div className="card-body p-4">
                                <h4 className="fw-bold mb-4">أرسل رسالة</h4>
                                
                                {/* رسالة النجاح */}
                                {showSuccess && (
                                    <div className="alert alert-success alert-dismissible fade show" role="alert">
                                        <strong>تم بنجاح!</strong> تم استلام رسالتك وسيتم الرد عليك قريباً.
                                        <button 
                                            type="button" 
                                            className="btn-close" 
                                            onClick={() => setShowSuccess(false)}
                                        ></button>
                                    </div>
                                )}

                                <form 
                                    id="contact-form" 
                                    name="contact-form" 
                                    onSubmit={handleSubmit}
                                    data-netlify="true"
                                    netlify
                                >
                                    {/* الحقول المخفية المطلوبة لـ Netlify */}
                                    <input type="hidden" name="form-name" value="contact-form" />
                                    <input type="hidden" name="_subject" value="رسالة جديدة من الموقع الشخصي" />

                                    <div className="mb-3">
                                        <label htmlFor="name" className="form-label">الاسم</label>
                                        <input 
                                            type="text" 
                                            className="form-control" 
                                            id="name" 
                                            name="name" 
                                            placeholder="أدخل اسمك" 
                                            required 
                                            disabled={isSubmitting}
                                        />
                                    </div>
                                   
                                    <div className="mb-3">
                                        <label htmlFor="email" className="form-label">البريد الإلكتروني</label>
                                        <input 
                                            type="email" 
                                            className="form-control" 
                                            id="email" 
                                            name="email" 
                                            placeholder="أدخل بريدك الإلكتروني" 
                                            required 
                                            disabled={isSubmitting}
                                        />
                                    </div>
                                   
                                    <div className="mb-3">
                                        <label htmlFor="subject" className="form-label">الموضوع</label>
                                        <input 
                                            type="text" 
                                            className="form-control" 
                                            id="subject" 
                                            name="subject" 
                                            placeholder="موضوع الرسالة" 
                                            required 
                                            disabled={isSubmitting}
                                        />
                                    </div>
                                   
                                    <div className="mb-3">
                                        <label htmlFor="message" className="form-label">الرسالة</label>
                                        <textarea 
                                            className="form-control" 
                                            id="message" 
                                            name="message" 
                                            rows="5" 
                                            placeholder="اكتب رسالتك هنا..." 
                                            required
                                            disabled={isSubmitting}
                                        ></textarea>
                                    </div>
                                   
                                    <button 
                                        type="submit" 
                                        className="btn btn-primary px-4 py-2"
                                        disabled={isSubmitting}
                                    >
                                        {isSubmitting ? (
                                            <>
                                                <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                                                جاري الإرسال...
                                            </>
                                        ) : (
                                            'إرسال الرسالة'
                                        )}
                                    </button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Contact;